import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { loaderBehavior } from '@stardust-ui/accessibility';
import * as customPropTypes from '@stardust-ui/react-proptypes';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { UIComponent, createShorthandFactory, commonPropTypes } from '../../lib';
import { withSafeTypeForAs } from '../../types';
import Box from '../Box/Box';
import Text from '../Text/Text';

/**
 * A loader alerts a user that content is being loaded or processed and they should wait for the activity to complete.
 */
var Loader =
/*#__PURE__*/
function (_UIComponent) {
  _inherits(Loader, _UIComponent);

  function Loader(props, context) {
    var _this;

    _classCallCheck(this, Loader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Loader).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "delayTimer", void 0);

    _this.state = {
      visible: _this.props.delay === 0
    };
    return _this;
  }

  _createClass(Loader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var delay = this.props.delay;

      if (delay > 0) {
        // @ts-ignore We have a collision between types from DOM and @types/node
        this.delayTimer = setTimeout(function () {
          _this2.setState({
            visible: true
          });
        }, delay);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.delayTimer);
    }
  }, {
    key: "renderComponent",
    value: function renderComponent(_ref) {
      var ElementType = _ref.ElementType,
          classes = _ref.classes,
          accessibility = _ref.accessibility,
          variables = _ref.variables,
          styles = _ref.styles,
          unhandledProps = _ref.unhandledProps;
      var _this$props = this.props,
          indicator = _this$props.indicator,
          label = _this$props.label,
          svg = _this$props.svg;
      var visible = this.state.visible;
      var svgElement = Box.create(svg, {
        defaultProps: function defaultProps() {
          return {
            className: Loader.slotClassNames.svg,
            styles: styles.svg
          };
        }
      });
      return visible && React.createElement(ElementType, _extends({
        className: classes.root
      }, accessibility.attributes.root, unhandledProps), Box.create(indicator, {
        defaultProps: function defaultProps() {
          return {
            children: svgElement,
            className: Loader.slotClassNames.indicator,
            styles: styles.indicator
          };
        }
      }), Text.create(label, {
        defaultProps: function defaultProps() {
          return {
            className: Loader.slotClassNames.label,
            styles: styles.label
          };
        }
      }));
    }
  }]);

  return Loader;
}(UIComponent);

_defineProperty(Loader, "create", void 0);

_defineProperty(Loader, "displayName", 'Loader');

_defineProperty(Loader, "className", 'ui-loader');

_defineProperty(Loader, "slotClassNames", {
  indicator: "".concat(Loader.className, "__indicator"),
  label: "".concat(Loader.className, "__label"),
  svg: "".concat(Loader.className, "__svg")
});

_defineProperty(Loader, "propTypes", Object.assign({}, commonPropTypes.createCommon({
  children: false,
  content: false
}), {
  delay: PropTypes.number,
  indicator: customPropTypes.itemShorthand,
  inline: PropTypes.bool,
  label: customPropTypes.itemShorthand,
  labelPosition: PropTypes.oneOf(['above', 'below', 'start', 'end']),
  size: customPropTypes.size,
  svg: customPropTypes.itemShorthand
}));

_defineProperty(Loader, "defaultProps", {
  accessibility: loaderBehavior,
  delay: 0,
  indicator: {},
  labelPosition: 'below',
  svg: '',
  size: 'medium'
});

Loader.create = createShorthandFactory({
  Component: Loader,
  mappedProp: 'label'
});
/**
 * A Loader alerts a user to wait for an activity to complete.
 *
 * @accessibility
 * Implements [ARIA progressbar](https://www.w3.org/TR/wai-aria-1.1/#progressbar) role.
 */

export default withSafeTypeForAs(Loader);